/*
 *  Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
 *  is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
 *  and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
 *
 *  You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
 *  in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
 *  forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
 *  explicitly covering such access.
 *
 *  The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
 *  which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
 *
 *  ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
 *  CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
 *  INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
 *  OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
 *  THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.
 *
 */

import React,{useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import { DOWNLOAD_TASK_TYPE } from '../../constants'
import { CameraControl, ControlGroup, FinderControl, GpsTraceControl } from '../map-controller'

const Controls = props => {
  const [isShowCameras, setCamerasShow] = useState(true)
  const [isGPSTrackerVisible, setGPSTrackerVisible] = useState(false)
  const [isCameraFinderVisible, setCameraFinderVisible] = useState(false)

  const {isGPSTrackerVisibleFromStore, isShowCamerasFromStore} = useSelector(({gpsTrace,map})=>({

    isGPSTrackerVisibleFromStore: gpsTrace.isGPSTrackerVisible,
    isShowCamerasFromStore: map.isShowCameras
  }))
  const {gpsTrace,map: mapAction} = useDispatch()

  const handleCameraFinderSwitchClick = ()=>{
    setCameraFinderVisible(!isCameraFinderVisible)
  }
  const handleGPSTrackSwitchClick = ()=>{
    setGPSTrackerVisible(!isGPSTrackerVisible)
    gpsTrace.updateState({isGPSTrackerVisible: !isGPSTrackerVisible})
  }
  const handleCameraShow = ()=>{
    setCamerasShow(!isShowCameras)
    mapAction.setCamerasShow(!isShowCameras)
  }
  return (
    <ControlGroup style={{ right: 10, bottom: 130 }}>
      <CameraControl actived={isShowCameras} onClick={handleCameraShow} />
      {/*
      <GpsTraceControl
        actived={isGPSTrackerVisible}
        disabled={false}
        // disabled={!isGPSTrackerEnable}
        onClick={handleGPSTrackSwitchClick}
      />
      <FinderControl
        onClick={handleCameraFinderSwitchClick}
        actived={isCameraFinderVisible}
        disabled={false}
      />
      */}
    </ControlGroup>
  )
}

export {
  Controls as default
}
